import * as React from "react";
import Translate from "../../../common/functions/translate";
import Spinner from '../../../common/components/spinner/spinner';
import Snackbar from "../../../common/components/snackbar/snackbar";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import RegionService from '../../../services/regionService';
import { RegionModel } from "../../../models/region/regionModel";
import { RegionFilterSettingsModel } from "../../../models/region/regionFilterSettingsModel";
import RegionList from './regionList';
import RegionAddEditdialog from './regionAddEditdialog';
import RegionFilter from './regionFilter';
import Button from "@material-ui/core/Button";

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  validationMessage: string;
  isVisibleAddEditDialog: boolean;
  isVisibleConfirmDialog: boolean;
  regionSettings: RegionFilterSettingsModel;
  regions: Array<RegionModel>;
  currentRegion: RegionModel;
}

const initFrom = 0;
const numberOfRows = 10;

class RegionsContainer extends React.Component<IProps, IState> {
  snackbar: any;
  regionService = new RegionService();
  messages: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      error: null,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      isVisibleAddEditDialog: false,
      isVisibleConfirmDialog: false,
      regionSettings: new RegionFilterSettingsModel(),
      regions: new Array<RegionModel>(0),
      currentRegion: new RegionModel()
    };
  }

  componentDidMount() {
    this.getAllRegions(this.state.from, this.state.numberOfRows);
  }

  getAllRegions(from: number, numberOfRows: number) {
    this.setState({
      isLoading: true
    });

    this.regionService.getAllRegions(from, numberOfRows, this.state.regionSettings).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          from: from,
          regions: data.regions,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleAddAndEditClick = id => {
    if (!id) { // Add			
      this.setCurrentRegion(new RegionModel());
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true
      });
      this.regionService.getRegion(id)
        .then(
          (data: RegionModel) => {
            this.setCurrentRegion(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          })
        .catch(error => {
          this.snackbar.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  };

  handleSaveButton = (region: RegionModel) => {
    this.setState({
      isLoading: true
    });

    if (!region.id) { // Add
      this.regionService.addRegion(region)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false })
            this.handleCloseAddEditRegionModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            })
          }
        );
    } else { // Edit
      this.regionService.editRegion(region)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false })
            this.handleCloseAddEditRegionModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            });
          });
    }
  };

  handleCloseAddEditRegionModal = () => {
    this.showEditDialog(false)
    this.setCurrentRegion(new RegionModel());
    this.getAllRegions(this.state.from, this.state.numberOfRows);
  };

  getRegion = (id) => {
    this.regionService.getRegion(id)
      .then(
        (data: RegionModel) => {
          this.setCurrentRegion(data);
          this.setState({
            isLoading: false
          });
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleDeleteClick = (id, e) => {
    e.stopPropagation();
    this.getRegion(id);
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteRegion(id) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.regionService.deleteRegion(id)
      .then(
        data => {
          this.snackbar.show({ severity: 'success', summary: Translate('Deleted Successfully') });
          this.getAllRegions(this.state.from, this.state.numberOfRows);
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentRegion(region: RegionModel) {
    this.setState({ currentRegion: { ...region } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleAddEditDialog: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleAddEditDialog: show
    }));
  };

  handleOnPageClick = (e) => {
    const startIndex = e.first;

    this.setState({
      numberOfRows: e.rows
    }, () => this.getAllRegions(startIndex, this.state.numberOfRows));
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true
    });

    this.regionService.getAllRegions(initFrom, numberOfRows, settings).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          from: initFrom,
          regions: data.regions,
          regionSettings: settings,
          totalRecordsCount: data.totalRecordsCount
        });
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  public render() {
    const { regions, isLoading, numberOfRows } = this.state;

    return (
      <div>
        <h1>{Translate("Regions")}</h1>

        {isLoading ? <Spinner /> : null}
        <Snackbar ref={(el) => this.snackbar = el} />

        {this.state.isVisibleAddEditDialog ? (
          <RegionAddEditdialog
            closeAddEditRegionModal={this.handleCloseAddEditRegionModal}
            cancelClick={this.handleCancelButton}
            saveClick={this.handleSaveButton}
            currentRegion={this.state.currentRegion}
            isVisible={this.state.isVisibleAddEditDialog}
          />
        ) : null}

        <RegionFilter
          onSearchClick={this.handleSearchButtonClick}
          totalRecordsCount={this.state.totalRecordsCount}
        />

        {this.state.totalRecordsCount
          ? <RegionList
            regions={regions}
            rows={numberOfRows}
            totalRecords={this.state.totalRecordsCount}
            onPageClick={this.handleOnPageClick}
            first={this.state.from}
            loading={Spinner}
            editClick={this.handleAddAndEditClick}
            deleteClick={this.handleDeleteClick}
          />
          : <div style={{ marginLeft: 10 }}>
            {Translate("NoRecordsFound")}
          </div>
        }

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
          <Button color="primary" variant="contained" style={{ marginBottom: 10 }} onClick={() => this.handleAddAndEditClick(null)}>
            {Translate("Add")}
          </Button>
        </div>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteRegion(this.state.currentRegion.id) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Are you sure that you want to delete")} "{this.state.currentRegion.name}"?
        </ConfirmDialog>
      </div>
    )
  }
}

export default RegionsContainer